"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = Object.freeze({
  MARKETING_STARTER: 'marketing-starter',
  MARKETING_PROFESSIONAL: 'marketing-pro',
  MARKETING_ENTERPRISE: 'marketing-enterprise'
});

exports.default = _default;
module.exports = exports.default;